import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment.local';

@Injectable()
export class PfacService {
  constructor(private http: HttpClient) {}

  public validateEligibility(cnpj: string): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUrls.pfac}/eligible/${cnpj}`).pipe(
      map((response) => response === true),
      catchError(() => of(false))
    );
  }
}
